module.exports = __webpack_public_path__ + "static/media/ph_stack-fill.75da2932.svg";